import { useEffect, useState } from 'react';
import { useDashboardContext } from '../DashboardContext';

const useActiveTabPane = () => {
    const {
        state: { displayLastMonth, displayCurrentMonth },
    } = useDashboardContext();
    const nextValue = displayLastMonth && !displayCurrentMonth ? '2' : '1';
    const [activeTabPaneKey, setActiveTabPaneKey] = useState(nextValue);

    useEffect(() => {
        setActiveTabPaneKey(nextValue);
    }, [nextValue, setActiveTabPaneKey]);

    return { activeTabPaneKey, setActiveTabPaneKey };
};

export default useActiveTabPane;
